import { EmailSmtpSettingsResponse } from '@/types/service-response'

export class EmailSmtpSettings {
  private constructor (
    readonly login: string,
    readonly password: string,
    readonly host: string,
    readonly port: number | string,
    readonly title: string,
    readonly useSsl: boolean,
    readonly senderEmail: string
  ) {}

  public static createListFromResponse (data: EmailSmtpSettingsResponse): EmailSmtpSettings {
    return new EmailSmtpSettings(
      data.Login,
      '',
      data.Host,
      data.Port,
      data.Title,
      data.UseSsl,
      data.SenderEmail
    )
  }

  public static create (login: string, password: string, host: string, port: number | string, title: string, useSsl: boolean, senderEmail: string): EmailSmtpSettings {
    return new EmailSmtpSettings(
      login,
      password,
      host,
      port,
      title,
      useSsl,
      senderEmail
    )
  }

}
